import { ViewOrderComponent } from './view-order/view-order.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndividualOrderComponent } from './individual-order/individual-order.component';
import { BulkOrdersComponent } from './bulk-orders/bulk-orders.component';
import { OrdersListingComponent } from './orders-listing/orders-listing.component';

const routes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'orders-list'
  },
  {
    path: 'individual-order',
    component:IndividualOrderComponent
  },
  {
    path: 'bulk-order',
    component:BulkOrdersComponent
  },
  {
    path: 'orders-list',
    component:OrdersListingComponent
  },
  {
    path: 'orders-list/:id',
    component:OrdersListingComponent
  },
  {
    path:'view-order/:id',
    component:ViewOrderComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderDetailsRoutingModule { }
